//requre third party modules
require('bootstrap-validator/dist/validator.min.js');
require('./modules/custom-event-polyfill.js');
require('./modules/mustache-tmpl.js');
require('./modules/date.js');
require('./modules/totop.js');
require('./modules/iconmap.js');
require('./modules/common.js');
require('./modules/menu.js');
require('./modules/search.js');
require('./modules/page-logic.js');
require('./modules/radio-buttons.js');
require('./modules/howispend-charts.js');